import { render, staticRenderFns } from "./PreviewForSp.vue?vue&type=template&id=3c8f6514"
import script from "./PreviewForSp.vue?vue&type=script&lang=js"
export * from "./PreviewForSp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports